import * as React from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { PredefinedObstacle } from "../../../../hooks/usePredefinedObstacle";
import { scrollSx } from "../../../../utils";

interface Props {
  obstacles: PredefinedObstacle[];
  selectedObstacle: PredefinedObstacle | null;
  onSelectObstacle: (obstacle: PredefinedObstacle, index: number) => void;
  onEditClick: (obstacle: PredefinedObstacle, event: React.MouseEvent) => void;
  onDeleteClick: (obstacle: PredefinedObstacle, event: React.MouseEvent) => void;
  tableRef: React.RefObject<HTMLDivElement>;
}

export const ObstacleTable: React.FC<Props> = ({
  obstacles,
  selectedObstacle,
  onSelectObstacle,
  onEditClick,
  onDeleteClick,
  tableRef,
}) => {
  return (
    <TableContainer
      ref={tableRef}
      component={Paper}
      sx={{ flex: 1, overflow: 'auto', maxHeight: '100%', ...scrollSx }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '15%', backgroundColor: 'background.default' }}>
              Name
            </TableCell>
            <TableCell align="right" sx={{ width: '10%', backgroundColor: 'background.default' }}>
              Width (ft)
            </TableCell>
            <TableCell align="right" sx={{ width: '10%', backgroundColor: 'background.default' }}>
              Length (ft)
            </TableCell>
            <TableCell align="right" sx={{ width: '10%', backgroundColor: 'background.default' }}>
              Height (ft)
            </TableCell>
            <TableCell align="center" sx={{ width: '10%', backgroundColor: 'background.default' }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {obstacles.map((obstacle, index) => (
            <TableRow
              key={obstacle.id}
              hover
              selected={selectedObstacle?.id === obstacle.id}
              onClick={() => onSelectObstacle(obstacle, index)}
              sx={{ cursor: 'pointer', height: '48px' }}
            >
              <TableCell>{obstacle.name}</TableCell>
              <TableCell align="right">{obstacle.width.toFixed(2)}</TableCell>
              <TableCell align="right">{obstacle.length.toFixed(2)}</TableCell>
              <TableCell align="right">{obstacle.height.toFixed(2)}</TableCell>
              <TableCell align="center">
                <Stack direction="row" spacing={1} justifyContent="center">
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={(e) => onEditClick(obstacle, e)}
                    sx={{ minWidth: 'auto' }}
                  >
                    Edit
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={(e) => onDeleteClick(obstacle, e)}
                    sx={{ minWidth: 'auto' }}
                  >
                    Delete
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};